export default "__VITE_ASSET__0b40e9d5__"